import { ability } from "@/libs/acl/ability";

export function tabIndexMaper(to, tabIndex){
    const parent = to.name;
    // const action = to.meta.action;
    const tabIndexNum = Number(tabIndex)

    const resourceMap = {
        "AddRevenueMain": {
            0: {type: "add_revenues", action:["create"]},
            1: {type: "add_revenues", action:["read"]},
            2: {type: "expense", action:["create"]},
            3: {type: "expense", action:["read"]},
            4: {type: "invoice", action:["create"]},
            5: {type: "invoice", action:["read"]}
        }
    }

    if (!resourceMap[parent]) {
        console.warn(`No resource map for parent route: ${parent}`);
        return null;
    }

    // Validate tab index exists
    if (resourceMap[parent][tabIndexNum] === undefined) {
        console.warn(`Invalid tab index: ${tabIndexNum} for route: ${parent}`);
        return null;
    }

    const resource = resourceMap[parent][tabIndexNum].type;
    const action = resourceMap[parent][tabIndexNum].action;
    if (!resource) {
        console.warn(`Empty resource for tab ${tabIndexNum} in route ${parent}`);
        return null;
    }


    return {
        status: ability.can(action, resource),
        parent: parent,
        maxTabs: Object.keys(resourceMap[parent]).length - 1,
        currentTab: tabIndexNum
    }

}

export function updateQuery(to, from, next, tab){
    if (!to.query.tabIndex && to.query.tabIndex !== 0) {
          return next({
            ...to,
            query: { ...to.query, tabIndex: tab? tab: 0 }
          });
    }
}